/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Count_No_ImageInputs */

const vi_shop_home_count_no_image = /** @type {(inputs: Shop_Home_Count_No_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`chưa có ảnh (ẩn)`)
};

/**

* @param {Shop_Home_Count_No_ImageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_count_no_image = /** @type {((inputs?: Shop_Home_Count_No_ImageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Count_No_ImageInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_count_no_image(inputs)
});